import React from "react";
import { Link, NavLink } from "react-router-dom";
import { BrandMark } from "../art/Icons";
import { BRAND_NAME } from "../../config/event";

export const NAV_LINKS = [
  { to: "/", label: "Domů", end: true },
  { to: "/reservations", label: "Rezervovat" },
  { to: "/manage", label: "Spravovat" },
  { to: "/info", label: "Info" },
];

const Navigation = () => (
  <header className="site-header">
    <div className="nav">
      <Link className="brand" to="/">
        <BrandMark />
        {BRAND_NAME}
      </Link>
      <nav className="tabs" aria-label="Navigace">
        {NAV_LINKS.map(({ to, label, end }) => (
          <NavLink key={to} to={to} end={end} className="tab">
            {label}
          </NavLink>
        ))}
      </nav>
    </div>
  </header>
);

export default Navigation;
